import { RoadwisePriceTagIcon } from "@talladega/icons";
import { Modal } from "@talladega/components";
import { useTranslation, Trans } from "next-i18next";

type Props = {
  promoCode: string;
  isOpen: boolean;
  onClose: () => void;
};

const PromoCodeAppliedModal = ({ promoCode, isOpen, onClose }: Props) => {
  const { t } = useTranslation(["common", "purchase"]);

  return isOpen ? (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t("purchase:promo_code_applied")}
      modalType="none"
      alignment="center"
      customIcon={<RoadwisePriceTagIcon className="h-24 w-24 text-[#506C99]" />}
    >
      <div className="flex flex-col gap-8 p-2">
        <h3 className="">
          <Trans
            t={t}
            i18nKey="purchase:your_promo_code_has_been_added"
            values={{
              name: promoCode.toUpperCase(),
            }}
            components={{
              b: <span className="font-semibold text-primary-500" />,
            }}
          />
        </h3>
        <p className="text-lg font-normal">
          {t("purchase:promo_code_applied_modal_description")}
        </p>
      </div>

      <div className="flex w-full justify-center">
        <Modal.Buttons
          primaryButtonText={t("purchase:take_a_look")}
          onPrimaryClick={onClose}
        />
      </div>
    </Modal>
  ) : null;
};

export default PromoCodeAppliedModal;
